<template>
  <main-wrapper>
    <button @click="updateDate">Click</button>
    <month :date="date" />
  </main-wrapper>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapActions, mapState } from "vuex";
import MainWrapper from "@/wrappers/MainWrapper.vue";
import { Month } from "@/components/Scheduler";

@Component({
  components: {
    MainWrapper,
    Month
  },
  methods: mapActions(["getScheduleByMonth", "getReservationsByMonth"])
})
export default class Test extends Vue {
  date = new Date()

  updateDate() {
    this.date = new Date(2020, 0, 1)
  }

  mounted() {
    console.log({ Month });
  }
}
</script>

<style lang="stylus" scoped></style>